<groundworks-card [title]="'Opportunity'" [action]="{ label: 'Deselect', click: onDeselect }">
  <groundworks-card-body>
    <div class="row g-3 mb-3">
      @switch (getState()) {
      @case ('loading') {
      <groundworks-state-message type="loading" message="Loading Opportunity..." class="d-flex" />
      }
      @case ('no-matches') {
      <groundworks-state-message type="no-matches" message="No Opportunity Found." class="d-flex" />
      }
      @case ('error') {
      <groundworks-state-message type="error" message="Error loading Opportunity." class="d-flex" />
      }
      @case ('matches') {
      @if (opportunity()) {
      <groundworks-opportunity-match-card [opportunity]="toOpportunityShape(opportunity()!)" [phases]="funnelPhases"
        [enableActivityPanel]="false" [enableAddressClick]="true" (addressClick)="onAddressClick()" />
      }
      }
      }
    </div>
  </groundworks-card-body>
</groundworks-card>
